import { Component, Injector, forwardRef, Input, OnDestroy, EventEmitter, Output, ChangeDetectorRef, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';

import { Observable, Subject } from 'rxjs';

import { SelectOption } from '@ui/components/form/common';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-combobox2',
    templateUrl: './input-combobox2.component.html',
    styleUrls: [
        '../input.component.scss',
        './input-combobox2.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputCombobox2Component),
            multi: true,
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputCombobox2Component extends InputBase<string> implements AfterViewChecked, OnDestroy
{
    private static identifier: number = 0;
    private destroyator = new Subject();
    public fieldId: string = `input-combobox2-${InputCombobox2Component.identifier++}-id`;
    public formGroup: UntypedFormGroup;
    @Input() items: Observable<SelectOption[]>;
    @Input() placeholder: string = '';
    @Input() inputDisabled: boolean;
    @Output() select: EventEmitter<string> = new EventEmitter<string>();

    constructor (
        injector: Injector,
        private changeDetectorRef: ChangeDetectorRef
    )
    {
        super(injector);
        this.formGroup = new UntypedFormGroup(
            {
                formControlName: new UntypedFormControl('', this.required ? Validators.required : [])
            });
    }

    ngAfterViewChecked ()
    {
        this.formGroup.get('formControlName').setValue(this.value);
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onSelected ()
    {
        this.value = this.formGroup.get('formControlName').value;
        this.select.emit(this.value);
    }
}
